import Papa from 'papaparse';
import { lowerCaseAndSpace } from '@utils/lowerCaseAndSpace';


const handleSaveData = async (data: any, removeColumns: []) => {
	console.log(data);
	try {
		const dataContent = data.map((row: any) => {
			// Apply lowerCaseAndSpace to each key in the row object
			const lowerCasedRow = {};
			for (const key in row) {
				if (row.hasOwnProperty(key)) {
					lowerCasedRow[lowerCaseAndSpace(key)] = row[key];
				}
			}
			return lowerCasedRow;
		});

		return dataContent;
	} catch (err) {
		console.log(err);
		return err;
	}
};

export default handleSaveData;
